import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_ADMIN_SAFETY_COMPLIANCE_API } from "./apiRoutes";

const getSafetyCompliance = async (): Promise<any> => {
  return await axiosAuth.get(DASHBOARD_ADMIN_SAFETY_COMPLIANCE_API);
};

const useGetSafetyCompliance = (queryParams?: Omit<UseQueryOptions, "queryKey">): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-safety-compliance"],
    queryFn: getSafetyCompliance,
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetSafetyCompliance;
